import { FormControl, FormHelperText, OutlinedInput } from "@mui/material";
import React from "react";

const AddGuestInput = (props) => {
  const {
    name,
    value,
    onChange,
    isError,
    width,
    onBlur,
    onFocus,
    placeholder,
    height,
    disabled,
    marginTop,
    helperText,
  } = props;
  return (
    <FormControl fullWidth error={isError}>
      <OutlinedInput
        placeholder={placeholder || "Enter guest email ID"}
        sx={{
          backgroundColor: "#FFFFFF",
          height: height || "8vh",
          width: width || "100%",
          borderRadius: "5px",
          marginTop: marginTop,
        }}
        name={name}
        onBlur={onBlur}
        onFocus={onFocus}
        value={value}
        onChange={onChange}
        autoComplete="off"
        disabled={disabled}
      />
      {helperText ? (
        <FormHelperText
          error={isError}
          sx={{ mx: 0, mt: 0.25, fontSize: 12, lineHeight: 1.2 }}
        >
          {helperText}
        </FormHelperText>
      ) : null}
    </FormControl>
  );
};

export default AddGuestInput;
